"use client";
import React, { useMemo } from "react";
import { cleanHeaderTags, createLookupObject } from "@/lib/helper";
import { ICMS } from "@/store/home/homeModel";
import { OptimizedImage } from "@/components/common/OptimizedImage";

interface TermsAndConditionProps {
  cmsData: ICMS[];
  bannerData: any[];
}

const TermsAndCondition: React.FC<TermsAndConditionProps> = ({
  cmsData,
  bannerData,
}) => {
  const lookUpCMSData = useMemo(() => {
    return createLookupObject(cmsData || [], "Name");
  }, [cmsData]);

  const banner =
    bannerData?.filter(
      (banner: any) => banner?.BannerType === "terms-and-condition",
    ) || [];

  return (
    <>
      <section className="relative h-[60vh] flex items-center justify-center overflow-hidden mt-24 bg-gradient-to-br from-[#1F3D2B] to-[#2A4F38]">
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60 z-10" />
        {banner?.length > 0 && banner[0]?.BannerImage && (
          <div className="absolute inset-0 z-0">
            <OptimizedImage
              src={banner[0]?.BannerImage}
              alt="Terms and Conditions Banner"
              fill
              priority
              className="object-cover"
            />
          </div>
        )}
        <div className="relative z-20 text-center px-6">
          <h1 className="text-white mb-6 drop-shadow-2xl">
            Terms And Conditions
          </h1>
        </div>
      </section>
      {lookUpCMSData["Terms And Conditions"] && (
        <section className="py-20 bg-gradient-to-b from-white to-[#F3EBDD]/30 cms-section">
          <div
            className="max-w-7xl mx-auto px-6 lg:px-8"
            dangerouslySetInnerHTML={{
              __html: cleanHeaderTags(
                lookUpCMSData["Terms And Conditions"]?.Template,
              ),
            }}
          />
        </section>
      )}
    </>
  );
};

export default TermsAndCondition;
